interface EnvConfig {
    API_BASE_URL: string;
    APP_ENV: 'development' | 'staging' | 'production';
    APP_VERSION: string;
}

// Default configuration for development
const defaultConfig: EnvConfig = {
    API_BASE_URL: 'https://madares.maksab.om',
    APP_ENV: 'development',
    APP_VERSION: process.env.REACT_APP_VERSION || '1.0.0',
};

// Environment-specific configuration
const envConfig: EnvConfig = {
    API_BASE_URL: process.env.REACT_APP_API_BASE_URL || defaultConfig.API_BASE_URL,
    APP_ENV: (process.env.REACT_APP_ENV as EnvConfig['APP_ENV']) || defaultConfig.APP_ENV,
    APP_VERSION: process.env.REACT_APP_VERSION || defaultConfig.APP_VERSION,
};

// Validate required environment variables
const validateConfig = (config: EnvConfig) => {
    const requiredVars = ['API_BASE_URL'] as const;
    const missingVars = requiredVars.filter(key => !config[key]);

    if (missingVars.length > 0) {
        throw new Error(
            `Missing required environment variables: ${missingVars.join(', ')}. ` +
            'Please check your .env file and environment configuration.'
        );
    }
};

validateConfig(envConfig);

export const config = {
    ...envConfig,
    isDevelopment: envConfig.APP_ENV === 'development',
    isStaging: envConfig.APP_ENV === 'staging',
    isProduction: envConfig.APP_ENV === 'production',
} as const; 